import axios from 'axios';
import { AJUSTAR_PONTOS_CLIENTE } from '../types';
import { URL } from '../../util/ambienteActions';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';

export default function ajustarPontosCliente(empresaId, clienteId, ajuste) {
    const url = `${URL}/configuracao-ponto/empresa/${empresaId}/ajustar-pontos/${clienteId}`;
    return dispatch => axios.post(url, ajuste, SLOW_REQUEST_CONFIG).then(
        response => dispatch({ type: AJUSTAR_PONTOS_CLIENTE, payload: response })
    );
}
